// extracted by mini-css-extract-plugin
export default {"component":"index-module__component--e+yAE"};